export const SCHEDULE_DEMO_MODAL_CLOSE = 'Payer Onboarding. Google Calendar Schedule. Close'
